<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <CreateEditCargoModal
      v-if="showCreateEditCargoModal"
      :cargoId="cargoIdSelected"
      @closeModal="closeCreateEditCargoModal"
    />
    <LoadingData v-if="loadData" />
    <div v-else class="card">
      <div
        class="card-header d-flex justify-content-between align-items-center bg-transparent border-bottom"
      >
        <h5 class="card-title mb-0">Cargos</h5>
        <div v-if="getModuleUserByCode('0.01.002')">
          <button
            type="button"
            class="btn btn-primary"
            title="Novo Usuário"
            @click="createEditCargo()"
          >
            Novo Cargo
          </button>
        </div>
      </div>
      <div class="card-body">
        <ListCargos :cargos="cargos" @editCargo="createEditCargo" />
      </div>
    </div>
  </Layout>
</template>

<script>
import { mapGetters } from 'vuex'
import Layout from '@/views/layouts/Layout.vue'
import PageHeader from '@/components/commons/PageHeader.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import CreateEditCargoModal from '@/components/administration/cargos/CreateEditCargoModal.vue'
import ListCargos from '../../../components/administration/cargos/ListCargos.vue'

export default {
  name: 'Cargos',

  components: {
    Layout,
    PageHeader,
    CreateEditCargoModal,
    LoadingData,
    ListCargos,
  },

  data() {
    return {
      title: 'Cargos',
      items: [
        {
          text: 'Administração',
        },
        {
          text: 'Cargos',
          active: true,
        },
      ],
      loadData: true,
      showCreateEditCargoModal: false,
      cargos: null,
      cargoIdSelected: null,
    }
  },

  computed: {
    ...mapGetters(['getModuleUserByCode']),
  },

  methods: {
    async getCargos() {
      try {
        this.cargos = await this.$store.dispatch('getCargos')
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$bvToast.toast(error.message, {
            title: 'Atenção!',
            variant: 'warning',
            solid: true,
          })
        } else {
          this.$root.$bvToast.toast(
            'Não foi possível se conectar ao servidor.',
            {
              title: 'Erro!',
              variant: 'danger',
              solid: true,
            },
          )
        }
      }
    },

    createEditCargo(cargoId) {
      this.cargoIdSelected = cargoId || null
      this.showCreateEditCargoModal = true
    },

    closeCreateEditCargoModal(loadListCargos) {
      if (loadListCargos) {
        this.getCargos()
      }
      this.showCreateEditCargoModal = false
    },
  },

  mounted() {
    this.getCargos()
  },
}
</script>
